var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIndexArrowGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.156 5L13.911.755l-1.015 1.016 2.51 2.51H.482v1.437h14.926L12.896 8.23l1.015 1.016L18.156 5z",
    fill: "#BDC1CF"
  })));
}
export default __webpack_public_path__ + "media/images/projectIndexArrowGray-e2bd4efc.svg";
export { SvgProjectIndexArrowGray as ReactComponent };